"use client"

import { useState } from "react"
import { Container, Row, Col, Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import MyBadgeOrdersList from "./MyBadgeOrdersList"
import BadgeRequestModal from "./BadgeRequestModal"
import MyBadgePreview from "./MyBadgePreview"
import { FaPlus, FaClipboardList, FaEye } from "react-icons/fa"

const BadgeRequestContainer = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(false)
  const [activeTab, setActiveTab] = useState<"orders" | "preview">("orders")

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleModalSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  const toggleTab = (tab: "orders" | "preview") => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <>
      <Breadcrumbs mainTitle="Badge Management" parent="Badge Management" />
      <Container fluid>
        {/* Header with Action Button */}
        <Row className="mb-4">
          <Col md="8">
            
            <small className="text-muted fw-bold">Manage your badge requests and preview your badge design</small>
          </Col>
          <Col md="4" className="text-end">
            <Button color="primary" onClick={handleOpenModal}>
              <FaPlus className="me-2" /> Request New Badge
            </Button>
          </Col>
        </Row>

        {/* Navigation Tabs */}
        <Row className="mb-4">
          <Col md="12">
            <Nav tabs className="border-bottom">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "orders" })}
                  onClick={() => toggleTab("orders")}
                  style={{ cursor: "pointer" }}
                >
                  <FaClipboardList className="me-2" />
                  My Badge Orders
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "preview" })}
                  onClick={() => toggleTab("preview")}
                  style={{ cursor: "pointer" }}
                >
                  <FaEye className="me-2" />
                  My Badge Preview
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>

        {/* Tab Content */}
        <TabContent activeTab={activeTab}>
          <TabPane tabId="orders">
            <Row>
              <Col md="12">
                <MyBadgeOrdersList refreshTrigger={refreshTrigger} />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="preview">
            <Row>
              <Col md="12">
                <MyBadgePreview />
              </Col>
            </Row>
          </TabPane>
        </TabContent>

        <BadgeRequestModal isOpen={modalOpen} toggle={() => setModalOpen(false)} onSuccess={handleModalSuccess} />
      </Container>
    </>
  )
}

export default BadgeRequestContainer
